module.exports = require('./helpers/bundle-url').getBundleURL('ciDtH') + "cl-logo.0b052307.svg";